import React, { useState } from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
  FormControlLabel,
  Checkbox
} from '@mui/material';
import { Add as AddIcon, Remove as RemoveIcon, TrendingUp as TrendingUpIcon } from '@mui/icons-material';

const BooleanFiltersSection = ({ onUpdate, booleanFieldOptions, boostInput = false }) => {
  const [currentField, setCurrentField] = useState('');
  const [currentValue, setCurrentValue] = useState(true);
  const [boost, setBoost] = useState(1);

  const handleFieldChange = (event) => {
    setCurrentField(event.target.value);
  };

  const handleBooleanAction = (actionType) => {
    if (!currentField) return;

    const updateData = {
      action: actionType,
      filter: 'term',
      field: currentField,
      value: currentValue
    };

    // Add boost value if boostInput is enabled
    if (boostInput) {
      updateData.boost = boost;
    }

    onUpdate(updateData);

    // Reset after adding
    setCurrentField('');
    setCurrentValue(true);
  };

  const getFieldLabel = () => {
    if (!currentField) return 'Value';
    const field = booleanFieldOptions.find(opt => opt.id === currentField);
    return field ? `Is ${field.label.toLowerCase()}` : 'Value';
  };

  return (
    <Box>
      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel>Boolean Field</InputLabel>
        <Select
          value={currentField}
          label="Boolean Field"
          onChange={handleFieldChange}
        >
          {booleanFieldOptions.map((option) => (
            <MenuItem key={option.id} value={option.id}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {currentField && (
        <FormControlLabel
          control={
            <Checkbox
              checked={currentValue}
              onChange={(e) => setCurrentValue(e.target.checked)}
            />
          }
          label={getFieldLabel()}
          sx={{ mb: 2, display: 'block' }}
        />
      )}

      {boostInput && (
        <TextField
          fullWidth
          sx={{ mb: 2 }}
          label="Boost"
          type="number"
          value={boost}
          onChange={(e) => setBoost(parseFloat(e.target.value) || 1)}
          inputProps={{ min: 0, step: 0.1 }}
        />
      )}

      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleBooleanAction('include')}
          disabled={!currentField}
        >
          <AddIcon />
        </Button>

        {boostInput && (
          <Button
            variant="contained"
            color="success"
            onClick={() => handleBooleanAction('boost')}
            disabled={!currentField}
          >
            <TrendingUpIcon />
          </Button>
        )}

        <Button
          variant="contained"
          color="error"
          onClick={() => handleBooleanAction('exclude')}
          disabled={!currentField}
        >
          <RemoveIcon />
        </Button>
      </Box>
    </Box>
  );
};

export default BooleanFiltersSection;

